import { useEffect } from "react";
import { REACT_APP_WEB_URL } from "../api/helpers";

const Users = () => {
  useEffect(() => {
    window.location.href = `${REACT_APP_WEB_URL}`;
  }, []);
  return <></>;
};

export default Users;
